<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Q1mtj/tc-custom/9781446357255.jpg?1740251696749" alt="This image is the cover for the book 3 Beautiful Bags"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">3 Beautiful Bags
      </h1>
      <p class="bookDescription body article font2">
        <p>Three sensational bag-making projects from Lisa Lam, bestselling author of <i>The Bag Making Bible</i></p><p>Includes all the sewing techniques and instructions you need to know to make the projects, from making adjustable straps to adding zips and magnetic snaps.</p><p>Download full-size templates direct from our website so you can print them out and get started straight away!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lisa Lam
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      F&#38;W Media International, Ltd
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0d9b0ad0